/* eslint-disable no-unused-vars */
import UpdateCommand from './UpdateCommand'
import CreateCommand from './CreateCommand'
import { firebase } from '@firebase/app'
import '@firebase/functions'
import axios from 'axios'
import './../../../vue.config'
const apiURL =  process.env.NODE_ENV == "production" ? "https://natracker-a7907.firebaseapp.com/natracker-a7907/us-central1/"  : "http://localhost:5000/natracker-a7907/us-central1/"

const Command = {
  execute: (command, payload) => {
    return Command[command] && Command[command](payload)
  },
  update: (payload) => { return UpdateCommand(payload) },
  create: (payload) => { return CreateCommand(payload) },
  updateReport: (payload) => {
    return firebase.functions().httpsCallable('updateReports')(payload)
  },
  updateHarvest: (payload) => {
    return firebase.functions().httpsCallable('updateHarvests')(payload)
  },
  upMasterDatAID: (payload) => {
    return firebase.functions().httpsCallable('upMasterDatAID')(payload)
  },
  updatePlans: (payload) => {
    return firebase.functions().httpsCallable('updatePlans')(payload)
  },
  getPlanStatistics: (payload) => {
    return firebase.functions().httpsCallable('getPlanStatistics')(payload)
  }
}
export default {
  install (Vue, options) {
    Vue.prototype.$command = Command
  }
}
